export const RegistrationMessages = {
  SECURITY_KEY_REGISTERED_SUCCESS:
    "Your security key was successfully registered!",
  OTP_PIN_SET_SUCCESS: "Your OTP PIN has been successfully set!",
  BADGE_PIN_SET_SUCCESS:
    "Your Badge PIN was successfully registered! You can now log in with Badge + PIN.",
} as const;

export const IdpApiConstants = {
  REGISTER_MFA_ENDPOINT: "api/v2/authn/webauthn/register",
  REGISTER_OTP_PIN_ENDPOINT: "api/v2/authn/otp/register/pin",
  REGISTER_OTP_KEY_ENDPOINT: "api/v2/authn/otp/register/key",
  WEBAUTHN_CREDENTIALS_BASE: "api/v2/authn/webauthn/credentials",
  REGISTER_BADGE_PIN_ENDPOINT: "api/v2/authn/badge-pin/register/pin",
  USERS_BASE: "api/v2/users",
  USERS_MYDIRECTS: "api/v2/users/mydirects",
  REGCODE_GENERATE: "api/v2/authn/regcode/generate",
};

export const PagePaths = {
  HOME: "/",
  REGISTER_MFA: "/register-mfa",
  SET_OTP_PIN: "/set-otp-pin",
  SET_BADGE_PIN: "/set-badge-pin",
  USER_PROFILE: "/users/:alias",
  MY_PROFILE: "/users/me",
  MANAGE_DIRECTS: "/manage-directs",
};

// Usage: https://badgephotos.corp.amazon.com?uid=jdoe
export const BadgePhotosUrl = "https://badgephotos.corp.amazon.com";

// Usage: https://phonetool.amazon.com/users/jdoe
export const PhoneToolUserUrl = "https://phonetool.amazon.com/users/:alias";

export const AmazonTeamsHomeUrl = "https://permissions.amazon.com/a";

export const YubicoPhishingResistantMfaUrl =
  "https://www.yubico.com/resources/glossary/phishing-resistant-mfa";

export const AppTitles = {
  DEFAULT: "Frontier Auth",
  REGISTRATION_WIZARD: "Frontier Auth Registration Portal",
} as const;

export const SupportUrls = {
  KIAM_INTEREST_CHANNEL_LINK:
    "https://amazon.enterprise.slack.com/archives/C07BWGH8FRN",
  KUIPER_IDENTITY:
    "https://t.corp.amazon.com/create/options?category=Kuiper&type=Identity%20and%20Access%20Mgmt&item=Identity&group=Kuiper%20Identity",
  ACCESS_ISSUE:
    "https://t.corp.amazon.com/create/templates/d50faac8-5649-4644-bfa5-e9eea079f469",
  BUG_REPORT:
    "https://t.corp.amazon.com/create/templates/c243370b-02e6-49a4-aeef-8680fec12316",
  FEATURE_REQUEST:
    "https://t.corp.amazon.com/create/templates/c2d9848f-c3f9-4823-a7f9-05881cfc885e",
  GROUPS_CONFIGURATION_REQUEST:
    "https://t.corp.amazon.com/create/templates/1b2b39ed-8dc6-482a-b47f-0711365006e5",
  RE_ENABLE_USER_REQUEST:
    "https://t.corp.amazon.com/create/templates/9ad13823-526c-48bb-9e09-622899988b69",
  YUBIKEY_REQUEST:
    "https://t.corp.amazon.com/create/templates/28c549e6-76fe-442f-b795-7d06860ae3d2",
};
